import type { ProfileChangeField, ProfileChangeValues } from '@/types/profileChanges';

export function changedProfileValues(fields: ProfileChangeField[], values: Record<string, string>): ProfileChangeValues {
  return fields.reduce<ProfileChangeValues>((changes, field) => {
    const value = (values[field.key] ?? '').trim();
    if (value !== (field.value ?? '')) changes[field.key] = value;
    return changes;
  }, {});
}

export function validProfileEvidence(file: Pick<File, 'name' | 'size' | 'type'>): boolean {
  return /\.(pdf|jpe?g|png)$/i.test(file.name)
    && ['application/pdf', 'image/jpeg', 'image/png'].includes(file.type)
    && file.size > 0 && file.size <= 10 * 1024 * 1024;
}

export function requiredProfileChangeValid(field: ProfileChangeField, value: string): boolean {
  return !field.required || value.trim() === (field.value ?? '') || value.trim().length > 0;
}
